/*
 * @Author: liuxw@codoon.com
 * @Date: 2020-07-03 12:47:35
 * @Last Modified by: liuxw@codoon.com
 * @Last Modified time: 2020-07-03 19:02:59
 * @Content:
 */

export default {
  // 地址卡片
  cardWrapper: {
    width: "82%",
    height: "fit-content",
    padding: "10px",
    backgroundColor: "rgba(248,248,248,1)",
    display: "flex",
    alignItems: "center",
    margin: "0 auto",
    borderRadius: "6px",
  },

  // 卡片左侧
  addressWrapper: {
    flex: 1,
    width: 'calc(100% - 30px)',
  },
  // 姓名、手机号
  titleWrapper: {
    display: "flex",
    alignItems: "center",
    color: "#222222",
    fontSize: "14px",
  },
  // 姓名
  userName: {
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    wordBreak: "break-all" as "break-all",
  },
  //手机号
  phoneNum: {
    marginLeft: "10px",
  },
  // 地址
  address: {
    color: "#B3B3B3",
    fontSize: "12px",
    paddingTop: "4px",
    whiteSpace: "nowrap" as "nowrap",
    textOverflow: "ellipsis",
    overflow: "hidden",
    wordBreak: "break-all" as "break-all",
  },

  // 卡片右侧编辑图标
  editIconWrapper: {
    width: "22px",
    height: "22px",
    marginLeft: "8px",
  },
  editIcon: {
    width: "22px",
    height: "22px",
  },
};
